import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { useFormikContext } from 'formik';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import { Button, Col, Modal, Row } from '@ui';

export type SubmitActions = 'save' | 'back' | 'save-continue';

export interface SubmitButtonsFormValues {
  submitType: SubmitActions | null;
}

const SubmitButtons = () => {
  const { t } = useTranslation(['onboarding', 'common']);
  const { intakeForm } = useEntityIntakeFormContext();
  const { values, isSubmitting, setFieldValue, submitForm } =
    useFormikContext<SubmitButtonsFormValues>();

  const onActionClick = async (key: 'save' | 'back' | 'save-continue') => {
    if (
      ['save', 'save-continue'].includes(key) &&
      intakeForm?.state !== 'draft'
    ) {
      Modal.confirm({
        width: 600,
        icon: null,
        closable: true,
        maskClosable: true,
        title: t('intake_form.submit_buttons.confirmation_modal.title'),
        content: t('intake_form.submit_buttons.confirmation_modal.description'),
        okText: t('proceed', { ns: 'common' }),
        cancelText: t('cancel', { ns: 'common' }),
        onOk: async () => {
          await setFieldValue('submitType', key);
          submitForm();
        },
      });
    } else {
      await setFieldValue('submitType', key);
      submitForm();
    }
  };

  return (
    <StyledRow gutter={[16, 16]}>
      <Col>
        <Button
          size="large"
          type="bordered"
          disabled={isSubmitting}
          loading={isSubmitting && values.submitType === 'back'}
          onClick={() => onActionClick('back')}
        >
          {t('intake_form.submit_buttons.back')}
        </Button>
      </Col>
      <Col>
        <Button
          size="large"
          type="bordered"
          disabled={isSubmitting}
          loading={isSubmitting && values.submitType === 'save'}
          onClick={() => onActionClick('save')}
        >
          {t('intake_form.submit_buttons.save')}
        </Button>
      </Col>
      <Col>
        <Button
          size="large"
          disabled={isSubmitting}
          loading={isSubmitting && values.submitType === 'save-continue'}
          onClick={() => onActionClick('save-continue')}
        >
          {t('intake_form.submit_buttons.save_continue')}
        </Button>
      </Col>
    </StyledRow>
  );
};

const StyledRow = styled(Row)`
  margin-top: ${({ theme }) => theme.marginSm};
`;

export default SubmitButtons;
